import Vue from 'vue'
import Router from 'vue-router'
import store from '@/store'
import App from '@/App'
import Home from '@/pages/Home'
import Login from '@/pages/Login'
import Dashboard from '@/pages/Dashboard'
import Settings from '@/pages/Settings'
import Tenancy from '@/pages/Tenancy'
import NotFound from '@/pages/NotFound'
import Forbidden from '@/pages/Forbidden'

import Index from '@/pages/Index'
import StatIndex from '@/pages/StatIndex'
import Single from '@/pages/Single'

Vue.use(Router)

const router = new Router({
  mode: 'history',
  routes: [
    {
      path: '/',
      component: App,
      children: [
        {
          path: 'erp/',
          component: Home,
          meta: { requiresAuth: true },
          children: [
            {
              path: 'stats/summary',
              component: Dashboard,
              name: 'summary',
              meta: {scope: ['stats.read']},
            },
            {
              path: 'stats/displays/regions',
              name: 'displayregions',
              component: StatIndex('statsdisplayregions'),
              meta: {scope: ['stats.read']},
            },
            {
              path: 'stats/displays/prints',
              name: 'displayprints',
              component: StatIndex('statsdisplayprints'),
              meta: {scope: ['stats.read']},
            },
            {
              path: 'stats/incidents/users',
              name: 'incidentusers',
              component: StatIndex('statsincidentusers'),
              meta: {scope: ['stats.read']},
            },
            {
              path: 'stats/incidents/regions',
              name: 'incidentregions',
              component: StatIndex('statsincidentregions'),
              meta: {scope: ['stats.read']},
            },
            {
              path: 'tenancy',
              component: Tenancy,
              name: 'tenancy',
              meta: {scope: ['stats.read']},
            },
            {
              path: 'settings',
              component: Settings,
              name: 'settings',
            },
            {
              path: 'regions',
              name: 'regions',
              component: Index('regions'),
              props: (route) => ({ error: route.query.error === 'true' }),
              meta: {scope: ['regions.read']},
            },
            {
              path: 'regions/:id',
              name: 'regionsSingle',
              component: Single('regions'),
              props: true,
              meta: {scope: ['regions.read']},
            },
            {
              path: 'cities',
              name: 'cities',
              component: Index('cities'),
              props: (route) => ({ error: route.query.error === 'true' }),
              meta: {scope: ['cities.read']},
            },
            {
              path: 'cities/:id',
              name: 'citiesSingle',
              component: Single('cities'),
              props: true,
              meta: {scope: ['cities.read']},
            },
            {
              path: 'districts',
              name: 'districts',
              component: Index('districts'),
              props: (route) => ({ error: route.query.error === 'true' }),
              meta: {scope: ['districts.read']},
            },
            {
              path: 'districts/:id',
              name: 'districtsSingle',
              component: Single('districts'),
              props: true,
              meta: {scope: ['districts.read']},
            },
            {
              path: 'boardtypes',
              name: 'boardtypes',
              component: Index('boardtypes'),
              props: (route) => ({ error: route.query.error === 'true' }),
              meta: {scope: ['boardtypes.read']},
            },
            {
              path: 'boardtypes/:id',
              name: 'boardtypesSingle',
              component: Single('boardtypes'),
              props: true,
              meta: {scope: ['boardtypes.read']},
            },
            {
              path: 'boards',
              name: 'boards',
              component: Index('boards'),
              props: (route) => ({ error: route.query.error === 'true' }),
              meta: {scope: ['boards.read']},
            },
            {
              path: 'boards/:id',
              name: 'boardsSingle',
              component: Single('boards'),
              props: true,
              meta: {scope: ['boards.read']},
            },
            {
              path: 'clients',
              name: 'clients',
              component: Index('clients'),
              props: (route) => ({ error: route.query.error === 'true' }),
              meta: {scope: ['clients.read']},
            },
            {
              path: 'clients/:id',
              name: 'clientsSingle',
              component: Single('clients'),
              props: true,
              meta: {scope: ['clients.read']},
            },
            {
              path: 'visuals',
              name: 'visuals',
              component: Index('visuals'),
              props: (route) => ({ error: route.query.error === 'true' }),
              meta: {scope: ['visuals.read']},
            },
            {
              path: 'visuals/:id',
              name: 'visualsSingle',
              component: Single('visuals'),
              props: true,
              meta: {scope: ['visuals.read']},
            },
            {
              path: 'baskets',
              name: 'baskets',
              component: Index('baskets'),
              props: (route) => ({ error: route.query.error === 'true' }),
              meta: {scope: ['baskets.read']},
            },
            {
              path: 'baskets/:id',
              name: 'basketsSingle',
              component: Single('baskets'),
              props: true,
              meta: {scope: ['baskets.read']},
            },
            {
              path: 'campaigns',
              name: 'campaigns',
              component: Index('campaigns'),
              props: (route) => ({ error: route.query.error === 'true' }),
              meta: {scope: ['campaigns.read']},
            },
            {
              path: 'campaigns/:id',
              name: 'campaignsSingle',
              component: Single('campaigns'),
              props: true,
              meta: {scope: ['campaigns.read']},
            },
            {
              path: 'available',
              name: 'available',
              component: Index('available'),
              props: (route) => ({ error: route.query.error === 'true' }),
              meta: {scope: ['faces.read']},
            },
            {
              path: 'faces',
              name: 'faces',
              component: Index('faceslist'),
              props: (route) => ({ error: route.query.error === 'true' }),
              meta: {scope: ['faces.read']},
            },
            {
              path: 'faces/:id',
              name: 'facesSingle',
              component: Single('faces'),
              props: true,
              meta: {scope: ['faces.read']},
            },
            {
              path: 'futurview',
              name: 'futurview',
              component: Index('futurview'),
              props: (route) => ({ error: route.query.error === 'true' }),
              meta: {scope: ['faces.read']},
            },
            {
              path: 'displays',
              name: 'displays',
              component: Index('displays'),
              props: (route) => ({ error: route.query.error === 'true' }),
              meta: {scope: ['displays.read']},
            },
            {
              path: 'displays/:id',
              name: 'displaysSingle',
              component: Single('displays'),
              props: true,
              meta: {scope: ['displays.read']},
            },
            {
              path: 'incidents',
              name: 'incidents',
              component: Index('incidents'),
              props: (route) => ({ error: route.query.error === 'true' }),
              meta: {scope: ['incidents.read']},
            },
            {
              path: 'incidents/:id',
              name: 'incidentsSingle',
              component: Single('incidents'),
              props: true,
              meta: {scope: ['incidents.read']},
            },
            {
              path: 'incidenttypes',
              name: 'incidenttypes',
              component: Index('incidenttypes'),
              props: (route) => ({ error: route.query.error === 'true' }),
              meta: {scope: ['incidenttypes.read']},
            },
            {
              path: 'incidenttypes/:id',
              name: 'incidenttypesSingle',
              component: Single('incidenttypes'),
              props: true,
              meta: {scope: ['incidenttypes.read']},
            },
            {
              path: 'interventiontypes',
              name: 'interventiontypes',
              component: Index('interventiontypes'),
              props: (route) => ({ error: route.query.error === 'true' }),
              meta: {scope: ['interventiontypes.read']},
            },
            {
              path: 'interventiontypes/:id',
              name: 'interventiontypesSingle',
              component: Single('interventiontypes'),
              props: true,
              meta: {scope: ['interventiontypes.read']},
            },
            {
              path: 'bookingsview',
              name: 'bookingsview',
              component: Index('bookingsview'),
              props: (route) => ({ error: route.query.error === 'true' }),
              meta: {scope: ['bookings.read']},
            },
            {
              path: 'users',
              name: 'users',
              component: Index('users'),
              props: (route) => ({ error: route.query.error === 'true' }),
              meta: {scope: ['users.read']},
            },
            {
              path: 'notifications',
              name: 'notifications',
              component: Index('notifications'),
            },
            {
              path: 'users/:id',
              name: 'usersSingle',
              component: Single('users'),
              props: true,
              meta: {scope: ['users.read']},
            },
            { path: '', redirect: 'available' },
            { path: 'forbidden', component: Forbidden, name: 'forbidden' },
            { path: '*', component: NotFound },
          ],
        },
        { path: '', redirect: '/erp' },
      ],
    },
    {
      path: '/login',
      component: Login,
      name: 'login',
    },
  ],
})
router.beforeEach((to, from, next) => {
  if (to.matched.some(record => record.meta.requiresAuth)) {
    let loggedIn = store.getters['auth/loggedIn']
    if (!loggedIn) {
      console.log('not logged in; checking auth')
      let token = store.getters['auth/token']
      store.dispatch('auth/checkAuth', token)
        .then(() => { next() })
        .catch(e => {
          console.log(e)
          next({
            name: 'login',
            query: { redirect: to.fullPath },
          })
        })
    } else {
      next() // make sure to always call next()!
    }
  } else {
    next() // make sure to always call next()!
  }
})

router.beforeEach((to, from, next) => {
  if (to.meta.scope) {
    let available = store.getters['auth/scope']
    store.dispatch('auth/checkAuthnz', {required: to.meta.scope, available})
      .then(() => { next() })
      .catch(e => {
        console.log(e)
        next({ name: 'forbidden' })
      })
  } else {
    next()
  }
})

export default router
